import { Component, OnInit } from '@angular/core';
import { MessageService } from '@bcone/neo-app-sdk';
export class LoginUser {
  email: string;
  password: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginUser: LoginUser;
  currentYear: Date = new Date();
  returnUrl: string;
  PathLocation: Location;
  LoginBtnVisible = true;
  appVersion: any;
  envData: any;
  link: any;
  constructor(private neoUtilService: MessageService) {
    this.envData = this.neoUtilService.getEnv();
    if (window.location.hostname === 'localhost' && this.envData) {

      this.link = this.envData.graphql_url.replace('graphql', 'apps');
      this.link = this.link.slice(0, -1);
    } else {
      let host = window.location.hostname;
      host = host.substr(host.indexOf('.'), host.length - host.indexOf('.'));
      this.link = `https://apps${host}`;
    }

  }

  ngOnInit() {
    this.appVersion = this.envData.app_version;
  }
}
